import _ from 'lodash'

export const calcMaxDomain = (minimalSize = 4) => dataMax => {
  const dataSize = _.size(`${dataMax}`)
  const closestData = _.floor(dataMax, (dataSize - 1) * -1)
  const diffData = dataMax - closestData
  const domainMaxSize = closestData + _.ceil(diffData || 1, (dataSize - 1) * -1)

  if (domainMaxSize < minimalSize) {
    return minimalSize
  }
  return domainMaxSize
}
